import cn from 'classnames';
import s from './style.css';
import calcAreaPercentage from 'utils/calcAreaPercentage';
import LineWrapper from 'components/LineWrapper';

const AreaComparison = ({
	data,
	masterCircleSize,
	masterCirclePercentage,
	wrapperClass,
	numberClass,
	inView,
	isEnd,
	color,
	topTight
}) => (
	<LineWrapper isEnd={isEnd} topTight={topTight}>
		<div className={cn(s.wrapper, { [s.hidden]: !inView })}>
			<div className={s.vizContainer}>
				{data.map(({ percentage, fact }, i) => (
					<div
						className={cn(s.circleWrapper, {
							[s.whiteBlue]: color === 'whiteBlue',
							[s.blueWhite]: color === 'blueWhite'
						})}
					>
						<div
							className={s.circle}
							style={{
								width: `${calcAreaPercentage(
									percentage,
									masterCirclePercentage
								) * 2}%`,
								height: `${calcAreaPercentage(
									percentage,
									masterCirclePercentage
								)}%`,
								transitionDelay: `${0.1 * i + 0.2}s`
							}}
						/>
						<p
							className={s.vizParagraph}
							style={{
								transitionDelay: `${0.1 * i + 0.4}s`
							}}
						>
							<span>{percentage}%</span> {fact}
						</p>
					</div>
				))}
			</div>
		</div>
	</LineWrapper>
);

export default AreaComparison;



// WEBPACK FOOTER //
// ./components/AreaComparison/index.js